import { render, staticRenderFns } from "./TableRowAvatar.vue?vue&type=template&id=4aabf758&scoped=true&"
import script from "./TableRowAvatar.vue?vue&type=script&lang=js&"
export * from "./TableRowAvatar.vue?vue&type=script&lang=js&"
import style0 from "./TableRowAvatar.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TableRowAvatar.vue?vue&type=style&index=1&id=4aabf758&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aabf758",
  null
  
)

export default component.exports